<template>
  <div>
    <Button type="success" 
@click="showScatter()">散点</Button>
  </div>
</template>
<script>
import MapScatter from './MapScatter';
export default MapScatter;
</script>
<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/components/mapscatter/MapScatter.vue